import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Col } from "reactstrap";
import { SelectItemsProps } from "./Select2Component";
import Skeleton from "react-loading-skeleton";

export type SelectComponentProps = {
    label: string;
    items: SelectItemsProps[] | ((...args: any[]) => Promise<SelectItemsProps[]>);
    onChange: (text: any) => void;
    selectedItemValue: string | null;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    style?: React.CSSProperties | undefined;
    class?: string | undefined;
    loading?: boolean;
    showLoadingSkeleton?: boolean;
    hideNotSelectedItem?: boolean;
    blockItem?: boolean;
    loadArgs?: any[]; // adicionar props dos métodods
};

export default function SelectComponent(props: SelectComponentProps) {
    const intl = useIntl();
    const [items, setItems] = useState<SelectItemsProps[]>([]);

    const onInputChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(e.target.value);
    };

    const isDisabled = (): boolean => {
        if (typeof props.loading !== "undefined" && props.loading === true) return true;
        return false;
    };

    const selectedItemValue = props.selectedItemValue ?? ""; // Garantir que não é null, devido ao value lançar erro

    useEffect(() => {
        const loadItems = async () => {
            if (typeof props.items === "function") {
                const loadedItems = await props.items(...(props.loadArgs || []));
                setItems(loadedItems);
            } else {
                setItems(props.items);
            }
        };

        loadItems();
    }, [props.items, props.loadArgs]);

    return (
        <Col xl={props.xl} lg={props.lg} md={props.md} sm={props.sm} xs={props.xs} className={`inputContainer ${props.class}`}>
            <span className="label">{props.label}:</span>

            {typeof props.showLoadingSkeleton !== "undefined" && props.showLoadingSkeleton === true ? (
                <>
                    <Skeleton height={"2rem"} />
                </>
            ) : (
                <>
                    <select
                        disabled={isDisabled() || props.blockItem}
                        value={selectedItemValue}
                        onChange={onInputChange}
                        className="select"
                        style={props.style}
                    >
                        {props.hideNotSelectedItem !== true && (
                            <option value={""}>{intl.formatMessage({ id: "SelectComponent.DefaultValue" })}</option>
                        )}

                        {items.length > 0 ? (
                            items.map((i: any) => (
                                <option key={i.value} value={i.value}>
                                    {i.label}
                                </option>
                            ))
                        ) : (
                            <option value={selectedItemValue}>{selectedItemValue}</option>
                        )}
                    </select>
                    {props.loading && (
                        <CircularProgress style={{ marginLeft: "0.5rem" }} size={"1.5em"} />
                    )}
                </>
            )}
        </Col>
    );
}